import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { KeyValueSet, LocalNetworkSettingWrapper, LocalPrinterName, LocalService, NetworkType, Status } from 'src/service/local.service';
import { OfflineService } from 'src/service/offline.service';

@Component({
  selector: 'app-config-machine',
  templateUrl: './config-machine.component.html',
  styleUrl: './config-machine.component.scss'
})
export class ConfigMachineComponent {
  @ViewChild('content_config_machine')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() title: string = ''; @Input() id: string = ''; @Input() businessId: string = '';
  item: LocalNetworkSettingWrapper; networkTypes: KeyValueSet[] = [];

  htmlId: string = ''; elementIds: any; sideBarBodyHeight: number = 10;

  currentPriterNames: KeyValueSet[] = []; newPriterNames: KeyValueSet[] = [];
  newMachineNames: KeyValueSet[] = [];

  constructor(private offcanvasService: NgbOffcanvas, private offlineService: OfflineService, public localService: LocalService, private configurationManagementService: ConfigurationManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      btn_navigate: 'btn_navigate_' + this.htmlId + '_',
      txt_quick_search: 'txt_quick_search_' + this.htmlId
    }
  }

  ngOnInit(): void {
    this.networkTypes = Object.keys(NetworkType)
      .map(function (x) {
        return {
          key: x.toString(),
          value: NetworkType[parseInt(x)]
        } as KeyValueSet;
      }).filter(x => x.key && x.value && x.key != '0');
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onReset() {
    this.currentPriterNames = [];
    this.newPriterNames = [];
    this.newMachineNames = [];
  }

  onCloseTrigger(event?: any) {
    this.onReset();
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.sideBarBodyHeight = window.outerHeight - 150;
    this.configurationManagementService.getLocalNetworkSetting(this.id, this.businessId).subscribe(result => {
      this.item = result;
      this.currentPriterNames = this.item.printers.map(x => {
        return {
          isSelected: true,
          value: x.PrinterName
        } as KeyValueSet;
      });
      this.item.item.NetworkType = this.item.item.NetworkType.toString();
    });
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        if (!(this.item.item.Title && this.item.item.Title.trim().length > 0)) {
          return;
        }
        if (!this.item.item.NetworkUrl.endsWith('/')) {
          this.item.item.NetworkUrl = this.item.item.NetworkUrl + '/';
        }
        this.item.printers = this.newPriterNames.filter(x => x.isSelected).map(x => {
          return {
            PrinterName: x.value,
          } as LocalPrinterName;
        });

        const currentPrinters = this.currentPriterNames.filter(x => x.isSelected).map(x => {
          return {
            PrinterName: x.value,
          } as LocalPrinterName;
        });

        this.item.printers.push(...currentPrinters);

        const selectedMachine = this.newMachineNames.find(x => x.isSelected);
        if (selectedMachine) {
          this.item.weightMachinePortPath = selectedMachine.key;
        }

        this.configurationManagementService.saveLocalNetworkSetting(this.item).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.onCloseTrigger();
          }
        });
      } break;
    }
  }

  onGetPrinterNames() {
    if (!(this.item.item.NetworkUrl && this.item.item.NetworkUrl.trim().length > 0)) {
      return;
    }
    if (!this.item.item.NetworkUrl.endsWith('/')) {
      this.item.item.NetworkUrl = this.item.item.NetworkUrl + '/';
    }
    this.offlineService.getLocalPrinters(this.item.item.NetworkUrl).subscribe(result => {

      const currentPrinterNames = this.currentPriterNames.map(x => x.value).filter(x => x && x.length > 0);
      this.newPriterNames = result.printerNames.filter(x => !currentPrinterNames.includes(x)).map(x => {
        return {
          isSelected: false,
          value: x
        } as KeyValueSet;
      });
    });
  }

  onGetMachineNames() {
    if (!(this.item.item.NetworkUrl && this.item.item.NetworkUrl.trim().length > 0)) {
      return;
    }
    if (!this.item.item.NetworkUrl.endsWith('/')) {
      this.item.item.NetworkUrl = this.item.item.NetworkUrl + '/';
    }
    this.offlineService.getLocalMachines(this.item.item.NetworkUrl).subscribe(result => {
      this.newMachineNames = [];
      result.forEach(x => {
        this.newMachineNames.push({
          isSelected: this.item.weightMachinePortPath == x.path ? true : false,
          value: x.path,
          key: x.path,
          s_value: x.currentWeight
        } as KeyValueSet);
      });

      if (this.newMachineNames.filter(x => x.isSelected == true).length == 0 && !(this.item.weightMachinePortPath && this.item.weightMachinePortPath.length > 1)) {
        const topElligibleItem = this.newMachineNames.find(x => x.s_value != '0');
        if (topElligibleItem) {
          this.newMachineNames.find(x => x.s_value != '0').isSelected = true;
        }
      }
    });
  }

  onChecked(key: string) {
    this.newMachineNames.forEach(x => {
      x.isSelected = x.key == key;
    });
  }
}
